import { Component, h } from '@stencil/core';
/**
 * @slot - This container displays the slotted contents at <ul><li>100% of the screen on small devices</li><li>33% of the screen on medium devices</li><li>50% of the screen on large devices.</li></ul>
 */
export class StatusContainerComponent {
  render() {
    return (h("div", { class: "status-container" },
      h("div", { class: "status-container__inner" },
        h("slot", null))));
  }
  static get is() { return "agl-ds-status-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["status-container.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["status-container.component.css"]
  }; }
}
